import React, { useContext } from "react";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import SectionHeader from "../components/section/SectionHeader";
import InfoAlert from "../ui/InfoAlert";
import OrgContext from "../store/orgContext";
import InlineLoader from "../components/loader/InlineLoader";
import NewDFSIConnection from "../components/dfsi/connections/NewDFSIConnection";
import {
  CREATE_DFSI_CONNECTION_TRANSLATIONS,
  LOADING_TEXT_TRANSLATIONS,
} from "../translations/util";

const NewDFSIConnections = () => {
  const { orgs: orgList, selectedOrg, updateOrg } = useContext(OrgContext);

  if (!orgList || orgList.length === 0) {
    return (
      <InlineLoader
        description={LOADING_TEXT_TRANSLATIONS.defaultLoadingText}
      />
    );
  }

  return (
    <>
      <SectionHeader
        pageTitle={CREATE_DFSI_CONNECTION_TRANSLATIONS.header}
        pageDescription={CREATE_DFSI_CONNECTION_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown
              disabled
              org={selectedOrg || undefined}
              orgsList={orgList}
              setOrg={updateOrg}
            />
          </div>
        }
      />

      <div className="main-content">
        {selectedOrg ? (
          <NewDFSIConnection org={selectedOrg.id} />
        ) : (
          <InfoAlert
            heading={CREATE_DFSI_CONNECTION_TRANSLATIONS.infoAlert.heading}
            subText={CREATE_DFSI_CONNECTION_TRANSLATIONS.infoAlert.subText}
          />
        )}
      </div>
    </>
  );
};

export default NewDFSIConnections;
